import { ReactNode } from 'react';

import {
  DialogCompositeMui as DialogComposite,
  MuiDialogControlledProps,
  MuiDialogStaticProps,
} from '../DialogCompositeMui';

export type RootProps = (
  | Omit<MuiDialogControlledProps, 'children' | 'ref'>
  | Omit<MuiDialogStaticProps, 'children' | 'ref'>
) & {
  children: ReactNode;
};

const Root = (props: RootProps) => {
  return <DialogComposite.Root {...props} />;
};

export default Root;
